import React, { useState, Children } from "react";
import "./styles.css";
import Vector from "../../../../assets/Blogs/Vector.png";

const FaqAccordion = ({ children }) => {
  const [open, setOpen] = useState(false);

  const childrenArray = Children.toArray(children);
  const question = childrenArray[0];
  const content = childrenArray.slice(1);

  return (
    <div className={`faq-accordion ${open ? "open" : ""}`}>
      <div className="faq-header" onClick={() => setOpen(!open)}>
        <span className="faq-question">{question}</span>

        <img
          className={`faq-arrow ${open ? "rotate" : ""}`}
          src={Vector}
          alt="toggle"
        />
      </div>

      {open && <div className="faq-content">{content}</div>}
    </div>
  );
};

export default FaqAccordion;
